import { isNil } from "lodash";
import { Node } from "#/decision_tree_viewer/models/node";
import { useStateStore } from "#/decision_tree_viewer/store/state";
import { stripHtml } from "#/shared/utils/string";

export class SelectStateNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SelectStateNode",

      question: undefined,

      matchType: "manually",
      matchingStates: [],
      selectedState: undefined,

      matchTargetNodeId: "continue",
      noMatchTargetNodeId: "continue",
    };
  }

  get currentState() {
    return { selectedState: this.selectedState };
  }

  get questionText() {
    return this.question || "";
  }

  get analyticsSummary() {
    if (!this.selectedState) {
      return null;
    }
    const { states } = useStateStore();
    const state = states.find((s) => s.id === this.selectedState);
    return {
      nodeType: this.name,
      nodeId: this.id,
      questionText: stripHtml(this.questionText).trim(),
      selectedAnswer: state?.name,
      selectedAnswerId: this.selectedState,
    };
  }

  get context() {
    let selectedStateName;
    if (this.selectedState) {
      const { states } = useStateStore();
      selectedStateName = states.find((state) => state.id === this.selectedState).name;
    }

    return {
      selectedState: this.selectedState,
      selectedStateName,
      selectStateNodeShown: true,
    };
  }

  get possibleNextNodeIds() {
    return [this.matchTargetNodeId, this.noMatchTargetNodeId];
  }

  autoAdvance(context) {
    return this.shouldSkip(context);
  }

  nextNodeId(context) {
    if (this.shouldSkip(context)) {
      return this.matchTargetNodeId;
    }

    if (this.selectedState === undefined) {
      return undefined;
    }

    if (this.conditionMatches(context)) {
      return this.matchTargetNodeId;
    }

    return this.noMatchTargetNodeId;
  }

  conditionMatches(context) {
    if (this.matchType === "manually") {
      return this.matchingStates.includes(this.selectedState);
    }

    if (isNil(context.providerLicensedStates)) {
      return true;
    }

    return context.providerLicensedStates.includes(this.selectedState);
  }

  reset() {
    this.selectedState = undefined;
  }

  // PRIVATE

  shouldSkip(context) {
    if (context.selectStateNodeShown && context.selectedState) {
      return true;
    }

    return this.matchType === "provider" && isNil(context.providerLicensedStates);
  }
}
